import React, { useState } from "react";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const CategoryListing = () => {
    const data = {
        labels: ["Vehicle Care", "Pet Care", "Gardening", "Handyman"],
        datasets: [
            {
                label: "This Year",
                data: [100, 86, 80, 60], // Update the percentages for each category
                backgroundColor: [
                    "#27648B", // Vehicle Care
                    "#E6EEF5", // Pet Care
                    "#27648B", // Gardening
                    "#E6EEF5", // Handyman
                ],
                borderRadius: 5,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 20,
                    callback: (value) => `${value}%`, // Display percentage values
                },
            },
        },
    };

    return (
        <div className="w-[320px] h-[200px] mt-4 lg:mt-0 lg:h-[400px] lg:w-full p-5 lg:p-14 bg-[#ffff] rounded-lg shadow-md">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold text-[#252C58]">Category Listing </h2>

            </div>
            <div className="w-full h-[250px] sm:h-[250px] md:h-[350px] lg:h-[400px]">

            <Bar data={data} options={options} />
            </div>
        </div>
    );
};

export default CategoryListing;
